var map = {
	"./clients.scss": [
		6669,
		1869
	],
	"./consulting-detail-course.scss": [
		1231,
		1869
	],
	"./consulting-entry.scss": [
		9234,
		1869
	],
	"./data-sheet.scss": [
		7561,
		1869
	],
	"./expert-opinion.scss": [
		8876,
		1869
	],
	"./highlight.scss": [
		6701,
		1869
	],
	"./info-premium.scss": [
		195,
		1869
	],
	"./magazine.scss": [
		5553,
		1869
	],
	"./meeting.scss": [
		5656,
		1869
	],
	"./new-box.scss": [
		6567,
		1869
	],
	"./new-entry.scss": [
		250,
		1869
	],
	"./new-opinion.scss": [
		5852,
		1869
	],
	"./new-video.scss": [
		7349,
		1869
	],
	"./rel.scss": [
		3246,
		1869
	],
	"./rules.scss": [
		5602,
		1869
	],
	"./submit-question.scss": [
		8878,
		1869
	],
	"./tab-detaile-couse.scss": [
		3367,
		1869
	],
	"./timeline.scss": [
		8268,
		1869
	],
	"./tools.scss": [
		9862,
		1869
	],
	"./topmost.scss": [
		5825,
		1869
	],
	"./vision-global.scss": [
		6369,
		1869
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9987;
module.exports = webpackAsyncContext;